import React, { createContext, useContext, useEffect, useReducer } from 'react'
import { createPortal } from 'react-dom'

import Notification from './Notification'
import { ADD_NOTIFICATION } from './NotificationEvent'
import { NotificationItem } from './types'

type ContextType = {
  notifications: NotificationItem[]
  notificationsDispatch: React.Dispatch<Action>
}
export const NotificationContext = createContext<ContextType>({} as ContextType)

const initialState: NotificationItem[] = []

export const ADD = 'ADD'
export const REMOVE = 'REMOVE'
export const REMOVE_ALL = 'REMOVE_ALL'

type Action = {
  type: 'ADD' | 'REMOVE' | 'REMOVE_ALL'
  payload: NotificationItem
}

export const notificationReducer = (
  state: NotificationItem[],
  action: Action
): NotificationItem[] => {
  switch (action.type) {
    case ADD:
      return [
        ...state,
        {
          id: +new Date(),
          ...action.payload,
        },
      ]
    case REMOVE:
      return state.filter(t => t.id !== action.payload.id)
    case REMOVE_ALL:
      return initialState
    default:
      return state
  }
}

export const NotificationProvider = (
  props: React.HTMLAttributes<HTMLElement>
): JSX.Element => {
  const [notifications, notificationsDispatch] = useReducer(
    notificationReducer,
    initialState
  )
  const notificationsData = { notifications, notificationsDispatch }

  const handleAddNotification = (e: any) => {
    notificationsDispatch({
      type: ADD,
      payload: e.detail,
    })
  }

  useEffect(() => {
    document.addEventListener(ADD_NOTIFICATION, handleAddNotification)

    return () =>
      document.removeEventListener(ADD_NOTIFICATION, handleAddNotification)
  })

  return (
    <NotificationContext.Provider value={notificationsData}>
      {props.children}

      {createPortal(
        <Notification notifications={notifications} />,
        document.body
      )}
    </NotificationContext.Provider>
  )
}

export const useNotificationContext = (): ContextType => {
  return useContext(NotificationContext)
}
